/**
 * Signal definitions and resolver.
 *
 * Primary source: rules.signal_definitions (via API /api/rules).
 * Fallback: local SIGNAL_MAP (used when rules are not yet loaded).
 *
 * Use resolveSignal(rules, key) for rules-aware lookups.
 * Use resolveSignals(rawSignals) for backwards-compatible bulk resolution.
 */

export const SIGNAL_MAP = {
  oel_heizung:            { label: 'Ölheizung',                               type: 'risk',     sev: 'Hoch' },
  gas_heizung:            { label: 'Gasheizung — CO₂-Abgabe steigt bis 2035', type: 'risk',     sev: 'Mittel' },
  nachtspeicher:          { label: 'Nachtspeicher',                            type: 'risk',     sev: 'Hoch' },
  elektro_heizung:        { label: 'Elektroheizung',                           type: 'caution',  sev: 'Mittel' },
  kohle_heizung:          { label: 'Kohleheizung',                             type: 'risk',     sev: 'Hoch' },
  waermepumpe:            { label: 'Wärmepumpe',                               type: 'positive', sev: 'Positiv' },
  fernwaerme:             { label: 'Fernwärme',                                type: 'caution',  sev: 'Mittel' },
  pellet_heizung:         { label: 'Pelletheizung',                            type: 'caution',  sev: 'Mittel' },
  bhkw:                   { label: 'BHKW',                                     type: 'positive', sev: 'Positiv' },
  geothermie:             { label: 'Geothermie',                               type: 'positive', sev: 'Positiv' },
  solar_thermie:          { label: 'Solarthermie',                             type: 'positive', sev: 'Positiv' },
  erbbaurecht:            { label: 'Erbbaurecht',                              type: 'risk',     sev: 'Hoch' },
  wohnrecht:              { label: 'Wohnrecht / Nießbrauch',                   type: 'risk',     sev: 'Hoch' },
  vorkaufsrecht:          { label: 'Vorkaufsrecht',                            type: 'caution',  sev: 'Mittel' },
  milieuschutz:           { label: 'Milieuschutz',                             type: 'caution',  sev: 'Mittel' },
  zwangsversteigerung:    { label: 'Zwangsversteigerung',                      type: 'risk',     sev: 'Hoch' },
  denkmalschutz:          { label: 'Denkmalschutz',                            type: 'caution',  sev: 'Mittel' },
  kernsaniert:            { label: 'Kernsaniert',                              type: 'positive', sev: 'Positiv' },
  renovierungsbedarf:     { label: 'Renovierungsbedarf',                       type: 'risk',     sev: 'Hoch' },
  erstbezug:              { label: 'Erstbezug',                                type: 'positive', sev: 'Positiv' },
  rohbau:                 { label: 'Rohbau',                                   type: 'caution',  sev: 'Mittel' },
  vermietet:              { label: 'Vermietet',                                type: 'caution',  sev: 'Mittel' },
  leerstand:              { label: 'Leerstand',                                type: 'caution',  sev: 'Mittel' },
  eigennutzer_kuendigung: { label: 'Eigenbedarfskündigung',                    type: 'caution',  sev: 'Mittel' },
  tg_stellplatz:          { label: 'Tiefgarage',                               type: 'positive', sev: 'Positiv' },
  stellplatz:             { label: 'Stellplatz',                               type: 'positive', sev: 'Positiv' },
  aufzug_vorhanden:       { label: 'Aufzug',                                   type: 'positive', sev: 'Positiv' },
  pv_anlage:              { label: 'PV-Anlage',                                type: 'positive', sev: 'Positiv' },
  einliegerwohnung:       { label: 'Einliegerwohnung',                         type: 'positive', sev: 'Positiv' },
  garten_vorhanden:       { label: 'Garten',                                   type: 'positive', sev: 'Positiv' },
  reetdach:               { label: 'Reetdach',                                 type: 'caution',  sev: 'Mittel' },
  hochwasser_risiko:      { label: 'Hochwasserrisiko',                         type: 'risk',     sev: 'Hoch' },
  laermbelastung_strasse: { label: 'Straßenlärm',                             type: 'risk',     sev: 'Mittel' },
  laermbelastung_bahn:    { label: 'Bahnlärm',                                type: 'risk',     sev: 'Mittel' },
  laermbelastung_flughafen:{ label: 'Fluglärm',                               type: 'risk',     sev: 'Mittel' },
  sonderumlage_geplant:   { label: 'Sonderumlage geplant',                    type: 'risk',     sev: 'Hoch' },
  ruecklage_niedrig:      { label: 'Rücklage niedrig',                        type: 'risk',     sev: 'Hoch' },
  keine_weg_verwaltung:   { label: 'Keine WEG-Verwaltung',                    type: 'caution',  sev: 'Mittel' },
  wbs_sozialbindung:      { label: 'WBS / Sozialbindung',                     type: 'caution',  sev: 'Mittel' },
  mietpreisbremse:        { label: 'Mietpreisbremse',                          type: 'caution',  sev: 'Mittel' },
  erbfall:                { label: 'Erbfall',                                  type: 'caution',  sev: 'Mittel' },
  scheidungsimmobilie:    { label: 'Scheidungsverkauf',                        type: 'caution',  sev: 'Mittel' },
  ferienwohnung:          { label: 'Ferienwohnung',                            type: 'caution',  sev: 'Mittel' },
  keine_provision:        { label: 'Provisionsfrei',                           type: 'positive', sev: 'Positiv' },
  hohe_provision:         { label: 'Hohe Provision',                           type: 'risk',     sev: 'Hoch' },
  vorkrieg:               { label: 'Vorkriegsbau',                             type: 'caution',  sev: 'Mittel' },
  hausgeld_hoch:          { label: 'Hausgeld hoch',                            type: 'risk',     sev: 'Hoch' },
  energie_h:              { label: 'Energieklasse H',                          type: 'risk',     sev: 'Hoch' },
  energie_g:              { label: 'Energieklasse G',                          type: 'risk',     sev: 'Hoch' },
  energie_f:              { label: 'Energieklasse F',                          type: 'risk',     sev: 'Mittel' },
  energie_e:              { label: 'Energieklasse E',                          type: 'caution',  sev: 'Mittel' },
  energie_a:              { label: 'Energieklasse A',                          type: 'positive', sev: 'Positiv' },
  energie_b:              { label: 'Energieklasse B',                          type: 'positive', sev: 'Positiv' },
};

/**
 * Resolve a single signal key using rules.signal_definitions when available,
 * falling back to the local SIGNAL_MAP.
 *
 * @param {object|null} rules - rules object from /api/rules (may be null while loading)
 * @param {string} key
 * @returns {{ label: string, type: string, severity: string, sev: string, key: string }}
 */
export function resolveSignal(rules, key) {
  // 1. Try rules engine (server-side source of truth)
  if (rules?.signal_definitions?.length) {
    const def = rules.signal_definitions.find(d => d.key === key);
    if (def) {
      return {
        key,
        label:    def.label,
        type:     def.type,
        severity: def.severity,
        // Map severity to legacy sev token used by SignalBadge
        sev: severityToSev(def.severity),
      };
    }
  }

  // 2. Fallback to local map
  const local = SIGNAL_MAP[key];
  if (local) return { ...local, key, severity: sevToSeverity(local.sev) };

  // 3. Unknown key — best-effort
  return {
    key,
    label:    key?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) || key,
    type:     'caution',
    severity: 'medium',
    sev:      'Mittel',
  };
}

/** Map rules.js severity to legacy sev label used by SignalBadge */
function severityToSev(severity) {
  switch (severity) {
    case 'critical':
    case 'high':   return 'Hoch';
    case 'medium': return 'Mittel';
    case 'low':    return 'Positiv'; // low on positive signals renders as Positiv
    default:       return 'Mittel';
  }
}

/** Reverse: local sev → severity string */
function sevToSeverity(sev) {
  switch (sev) {
    case 'Hoch':    return 'high';
    case 'Positiv': return 'low';
    default:        return 'medium';
  }
}

/**
 * Resolve raw signal keys (from API) into structured signal objects.
 *
 * Primary source: rules.signal_definitions (Array aus /api/rules oder rulesFallback).
 * Fallback: lokaler SIGNAL_MAP.
 * Letzter Fallback: generisches Objekt mit key als Label.
 *
 * @param {Array<string|{key:string}>} rawSignals
 * @param {object|null} [rules] - Rules-Objekt aus useRules() (optional, rückwärtskompatibel)
 * @returns {Array<{label:string, type:string, sev:string, key:string}>}
 */
export function resolveSignals(rawSignals, rules) {
  if (!rawSignals?.length) return [];
  return rawSignals.map(entry => {
    const k = typeof entry === 'string' ? entry : entry?.key;
    return resolveSignal(rules, k);
  });
}
